import { Box } from "@mui/material";
import React, { Component } from "react";

export default class BreakpointIndicator extends Component<any, any> {
  constructor(props: any) {
    super(props);

    this.state = {
      deviceWidth: window.innerWidth,
      currentBreakpoint: props.theme.getCurrentBreakpoint(),
    };

    window.addEventListener("resize", () =>
      this.setState({
        deviceWidth: window.innerWidth,
        currentBreakpoint: this.props.theme.getCurrentBreakpoint(),
      })
    );
  }

  render() {
    const { theme } = this.props;
    const { currentBreakpoint, deviceWidth } = this.state;

    const breakpointIndex = Object.keys(theme.breakpoints.values).findIndex(
      (b) => b === currentBreakpoint[0]
    );
    const indicatorWidth =
      (deviceWidth * (breakpointIndex * 24)) / currentBreakpoint[1] - 0;

    return (
      <div className="klayo-breakpointindicator">
        <div
          className="klayo-breakpointindicator_indicator"
          style={{ width: indicatorWidth + "px" }}
        ></div>
        {Object.keys(theme.breakpoints.values).map((b, key) => (
          <Box
            key={key}
            className="klayo-breakpointindicator_item"
            sx={{
              [theme.breakpoints.only(b)]: {
                fontWeight: "800",
                color: "black",
              },
            }}
          >
            {b}
          </Box>
        ))}
      </div>
    );
  }
}
